import loadable from '@loadable/component'

export default [
  {
    // 帮助与客服
    path: '/code/HelpCenter/HelpAndService',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-HelpCenter-HelpAndService" */ '~/pages/r_code/HelpCenter/HelpAndService'
        )
    ),
  },
  {
    // 猜你想问
    path: '/code/HelpCenter/GuessYourAsk',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-HelpCenter-GuessYourAsk" */ '~/pages/r_code/HelpCenter/GuessYourAsk'
        )
    ),
  },
  {
    // 问题列表
    path: '/code/HelpCenter/ProblemList/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-HelpCenter-ProblemList" */ '~/pages/r_code/HelpCenter/ProblemList'
        )
    ),
  },
  {
    // 问题详情
    path: '/code/HelpCenter/ProblemDetail/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-HelpCenter-ProblemDetail" */ '~/pages/r_code/HelpCenter/ProblemDetail'
        )
    ),
  },
  {
    // 帮助中心
    path: '/code/Helping/Center',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-Helping-Center" */ '~/pages/r_code/Helping/Center'
        )
    ),
  },
  {
    // 问题合集
    path: '/code/Helping/QuestionTypes',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-Helping-QuestionTypes" */ '~/pages/r_code/Helping/QuestionTypes'
        )
    ),
  },
  {
    // 工单历史列表
    path: '/code/Helping/ReportList',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-Helping-ReportList" */ '~/pages/r_code/Helping/ReportList'
        )
    ),
  },
  {
    // 工单结果反馈
    path: '/code/Helping/ReportResNotify',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-Helping-ReportResNotify" */ '~/pages/r_code/Helping/ReportResNotify'
        )
    ),
  },
  {
    // 工单详情
    path: '/code/Helping/ReportDetails',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-Helping-ReportDetails" */ '~/pages/r_code/Helping/ReportDetails'
        )
    ),
  },
  {
    // 问题合集
    path: '/code/Helping/Question/Edit',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-Helping-Question-Edit" */ '~/pages/r_code/Helping/Question/Edit'
        )
    ),
  },
  {
    // 问题合集
    path: '/code/Helping/Question/View/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-Helping-Question-View" */ '~/pages/r_code/Helping/Question/View'
        )
    ),
  },
]
